import _ from 'lodash';

import { Application } from 'backbone.marionette';
import RootLayout from './layouts/Root';
import { HeaderView, TippingMenuView } from './views';
import { MenuModel, User as UserModel } from './models';
import { FooterView } from "./views";
import { Secret } from '../../core/utils';
import routers from './routers';
import { Rounds } from "./collections";
import { isAuthorized } from '../../core/utils';

const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON);

export default class App extends Application {
	constructor(args) {
		super({
			...args,
			region: '#app'
		});
	}

	_initRouters(params) {
		const { PreseasonRouter, ...other_routers } = routers;

		if (IS_PRE_SEASON) {
			new PreseasonRouter(params);

			return this;
		}

		_.each(other_routers, Router => new Router(params));

		return this;
	}

	async onStart() {
		const rootView = new RootLayout();

		const params = new URLSearchParams(location.search.substr(1));

		if (!isAuthorized() && params.get("from_app") && params.get("token")) {
			await UserModel.loginWithVerifyToken({
				token: params.get("token"),
			});
			params.delete('token');
			params.delete('from_app');
			location.reload()
			return false;
		}

		if (!IS_PRE_SEASON) {
			const
				headerView = new HeaderView(),
				menu = new TippingMenuView({
					rounds: new Rounds(),
					model: new MenuModel()
				}),
				footerView = new FooterView();

			rootView.getRegion('menu').show(menu);
			rootView.getRegion('header').show(headerView);
			rootView.getRegion('footer').show(footerView);
		}

		this._initRouters({ rootView }).showView(rootView);

		if (UserModel.user) {
			await UserModel.update();
		}
	}
}